export const inventionRegisterOptions = [
  { label: "En investigación", value: "IN_RESEARCH" },
  { label: "Solicitado", value: "REQUESTED" },
  { label: "Otorgado", value: "GRANTED" }
];